/**
 *
 * IBM Confidential
 *
 * (C) Copyright IBM Corp. 2022, 2025
 *
 * The source code for this program is not published or otherwise
 * divested of its trade secrets, irrespective of what has been
 * deposited with the U. S. Copyright Office
 *
 * US Government Users Restricted Rights - Use, duplication or
 * disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 *
 **/

import type { DeployEnv } from '@ibm-watson/shared/ts';

export type BluemixAnalytics = {
  trackEvent: (eventName: string, eventData: any) => void;
  pageEvent: (eventName: string, eventData: any) => void;
  identify: (identifyData: any) => void;
};

export const enum Ut30Code {
  WXO = '30AS5',
  WXA = '30A47'
}

export const enum ProductCode {
  WXOAWS = 'WW1035',
  WXOIBM = 'WW2362',
  WXA = 'BMXZ102'
}

export const enum ProductId {
  WXOAWS = '5900AN0',
  WXOIBM = '5900BEK',
  WXA = '5737A54'
}

export const enum ProductTitle {
  WXO = 'watsonx Orchestrate',
  WXA = 'Watson Assistant'
}

export const enum CloudEnvironment {
  AWS = 'AWS',
  IBM = 'IBM'
}

export const enum PlatformTitle {
  WXO = 'Assistant Builder',
  WXA = 'watsonx Assistant'
}

export const ProductCodeType = 'WWPC';

export interface SegmentCommonProperties {
  productId: ProductId;
  productTitle: ProductTitle;
  environment: DeployEnv;
  UT30: Ut30Code;
  productCode: ProductCode;
  productCodeType: typeof ProductCodeType;
  platformTitle: PlatformTitle;
  cloudEnvironment: CloudEnvironment;
  instanceId: string;
  instanceGuid: string;
}
